export default __webpack_public_path__ + "static/media/ic-edit.36724576.svg";